export const BESCHEID_ANGELEGT = "ANGELEGT";
export const BESCHEID_BEANTRAGT = "BEANTRAGT";
export const BESCHEID_IN_BEARBEITUNG = "IN_BEARBEITUNG";
export const BESCHEID_FREIGEGEBEN = "FREIGEGEBEN";

export function bescheidstatusIdToObj(id) {
    switch (id) {
        case BESCHEID_ANGELEGT:
            return { id: BESCHEID_ANGELEGT, value: "angelegt" };
        case BESCHEID_BEANTRAGT:
            return { id: BESCHEID_BEANTRAGT, value: "beantragt" };
        case BESCHEID_IN_BEARBEITUNG:
            return { id: BESCHEID_IN_BEARBEITUNG, value: "in Bearbeitung" };
        case BESCHEID_FREIGEGEBEN:
            return { id: BESCHEID_FREIGEGEBEN, value: "freigegeben" };
        default:
            return null;
    }
}
